/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./Etoday.vue?vue&type=template&id=56799ce0&"
import script from "./Etoday.vue?vue&type=script&lang=js&"
export * from "./Etoday.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports